var render = function render(){var _vm=this,_c=_vm._self._c;return _c('font-awesome-layers',{staticClass:"fa-fw icon-layer",class:_vm.factor},[_c('font-awesome-icon',{style:(_vm.circle),attrs:{"icon":"circle"}}),(_vm.icon)?_c('font-awesome-icon',{staticClass:"inverse",attrs:{"icon":_vm.icon,"transform":"shrink-6"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }